import React from 'react';
import { Card } from '../components/ui/card';
import { FileText } from 'lucide-react';
import SEO from '../components/SEO';

const TermsOfService = () => {
  return (
    <main className="pt-24 bg-[#FDFDFB]">
      <SEO 
        title="Terms of Service"
        description="Terms of service for using the Harmony Behavioral & Psychiatric Health website."
      />

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <Card className="p-8 md:p-12 bg-white border-[#d4cec5]">
              <div className="flex items-center gap-3 mb-6">
                <FileText className="text-[#7a8a72]" size={40} />
                <h1 className="text-4xl font-bold text-[#7a8a72]">Terms of Service</h1>
              </div>

              <h2 className="text-2xl font-semibold text-[#7a8a72] mb-6">Harmony Behavioral & Psychiatric Health</h2>

              <p className="text-[#3a3a3a] mb-6 leading-relaxed">
                By accessing or using this website, you agree to the following Terms of Service:
              </p>

              <div className="space-y-8 text-[#3a3a3a]">
                <div>
                  <h3 className="text-xl font-semibold text-[#7a8a72] mb-3">1. Use of Website</h3>
                  <p className="leading-relaxed">
                    This website is provided for informational purposes only. You agree to use this site lawfully and in accordance with all applicable laws and regulations.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-[#7a8a72] mb-3">2. No Medical Relationship</h3>
                  <p className="leading-relaxed">
                    Use of this website does not create a provider–patient relationship. A provider–patient relationship is established only through a formal clinical appointment, completed intake, and proper documentation.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-[#7a8a72] mb-3">3. No Emergency Services</h3>
                  <p className="leading-relaxed">
                    This website is not intended for emergency use. Do not use this website to seek emergency medical or psychiatric assistance.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-[#7a8a72] mb-3">4. Accuracy of Information</h3>
                  <p className="leading-relaxed">
                    Harmony Behavioral & Psychiatric Health does not guarantee that website content is complete, current, or error-free.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-[#7a8a72] mb-3">5. Intellectual Property</h3>
                  <p className="leading-relaxed">
                    All content, text, graphics, logos, branding, and design elements on this website are the property of Harmony Behavioral & Psychiatric Health and may not be copied, reproduced, distributed, or reused without written permission.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-[#7a8a72] mb-3">6. Third-Party Links</h3>
                  <p className="leading-relaxed">
                    This website may contain links to third-party websites and services, including patient portals and partner practices. Harmony Behavioral & Psychiatric Health is not responsible for the content, policies, or practices of third-party websites.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-[#7a8a72] mb-3">7. Limitation of Liability</h3>
                  <p className="leading-relaxed">
                    Harmony Behavioral & Psychiatric Health shall not be liable for any damages arising from the use or inability to use this website.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-[#7a8a72] mb-3">8. Modifications</h3>
                  <p className="leading-relaxed">
                    We reserve the right to update or modify these Terms of Service at any time. Changes will be posted on this website.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-[#7a8a72] mb-3">9. Governing Law</h3>
                  <p className="leading-relaxed">
                    These Terms shall be governed by the laws of the jurisdictions in which Harmony Behavioral & Psychiatric Health operates, including Tennessee, Georgia, Maryland, and the District of Columbia.
                  </p>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </section>
    </main>
  );
};

export default TermsOfService;